<template>
    <section class="blockElement space connectingBroker vh-100">
        <Header />
        <div class="container calcPadding">
            <div class="row justify-content-center align-items-center heightCalc">
                <div class="col-12 col-lg-9 text-center">
                     <div class="connectingAccount d-flex justify-content-center align-items-center mb-5">
                        <span class="ZuluDemo"><img src="assets/images/ZuluDemo.svg" :alt="$t('demo_account.text18')" :title="$t('demo_account.text18')" /></span>
                     </div>
                     <div class="content max-600">
                        <h2 class="mb-4 semibold">{{$t('demo_account.text1')}}</h2>
                        <h6 class="f-18 mb-4 pb-md-3">{{$t('demo_account.text2')}}</h6>
                        <h6 class="f-18 mb-4 pb-md-3">{{$t('demo_account.text2')}}</h6>
                        <a href="javascript:void(0)" class="grd_btn semibold mb-3">{{$t('demo_account.text3')}}</a>
                        <div class="d-block">
                            <a href="javascript:void(0)" class="link">{{$t('demo_account.text4')}}</a>
                        </div>
                     </div>
                </div>
            </div>
        </div>
        <stepFooter />
    </section>
</template>
<script>
    import stepFooter from "../../components/shared/step_footer";
    export default {
        setup() {
           
        },
        components: { 
            stepFooter 
        },
        data() {
            return {
               
            };
        },
    };
</script>